<script>
import Vue from 'vue';
import {mapState} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            loading: state => state.account.loading
        })
    }
});
</script>

<template>
    <div class="account-avatar">
        <div class="account-avatar__icon">
            <i class="fa fa-user"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AccountAvatar/AccountAvatar.vue